var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHand3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9728 14.5L11.9745 11.3211C11.9744 11.2325 11.9805 11.1455 11.9923 11.0606M11.9923 11.0606C12.1037 10.258 12.7252 9.50088 13.4758 9.5H13.4773C14.3083 9.5 14.9819 10.394 14.9819 11.3212L14.9835 12.3211M11.9923 11.0606V7.67881C11.9923 6.75164 11.3187 6.00001 10.4877 6.00001H10.4862C9.65615 6.00098 8.984 6.75258 8.98486 7.67874C8.99197 14.235 8.99142 16.0122 8.9832 16.0103C7.60515 16.0103 6.56185 13.0567 4.75285 13.0567C2.9438 13.0567 2.64025 14.13 3.36312 15.0797C3.84504 15.7128 8.9832 22 8.9832 22H16.9999C19.209 22 20.9998 20.2092 20.9999 18.0001L21 13.5C21 12.5728 20.3264 11.8212 19.4954 11.8212H19.4939C18.6639 11.8222 17.9917 12.5738 17.9926 13.4999L17.9909 14.5M14.9835 12.3211V14.5M14.9835 12.3211C14.9827 11.395 15.6548 10.6434 16.4849 10.6424H16.4864C17.3173 10.6424 17.9909 11.394 17.9909 12.3212V13.5M15.3553 7.85918C15.41 7.56472 15.4385 7.26108 15.4385 6.95077C15.4385 4.21654 13.222 2 10.4877 2C7.75345 2 5.53694 4.21654 5.53694 6.95077M15.3553 7.85918L13.705 6.20893M15.3553 7.85918L17.0056 6.20893",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHand3);
export default __webpack_public_path__ + "static/media/hand3.43a27688b49866b83f4976743d7072bd.svg";
export { ForwardRef as ReactComponent };